import keyMirror from 'key-mirror';
import { createActions } from 'redux-actions';

export const constants = keyMirror({
  SET_CARD_COMPLETED: null,
});

export const { setCardCompleted } = createActions(constants.SET_CARD_COMPLETED);
